
import React, { useEffect, useState } from "react";
import { fetchStock_balancesheet } from "../../ApisService/apiService";
import styles from "../../../css/dashboard/fundamental/Profitloss.module.css";


const BalanceSheet = ({ selectedCompany }) => {
  const [Bsdata, setBsdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (!selectedCompany || !selectedCompany.fincode) {
      setBsdata([]);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const Balancesheet_data = await fetchStock_balancesheet(selectedCompany.fincode);
        setBsdata(Balancesheet_data.data || []);
      } catch (err) {
        setError("Failed to fetch data.");
      }
      setLoading(false);
    };

    fetchData();
  }, [selectedCompany]);

  const toggleRowVisibility = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!selectedCompany) {
    return <p className={styles.errorText}>No company selected.</p>;
  }

  const years = Bsdata.map((item) => item.Year_end);

  const financialData = [
    { type: "heading", label: "EQUITY AND LIABILITIES " },
    { type: "data", label: "Share Capital", key: "Share_Capital", expandable: true },
    { type: "subdata", label: "    Equity - Authorised", key: "Equity_Authorised", parentKey: "Share_Capital" },
    { type: "subdata", label: "    Equity - Issued", key: "Equity_Issued", parentKey: "Share_Capital" },
    { type: "subdata", label: "    Equity Paid Up", key: "EQUITY_PAIDUP", parentKey: "Share_Capital" },
    { type: "subdata", label: "    Equity Shares Forfeited", key: "Equity_Forfeited", parentKey: "Share_Capital" },
    { type: "subdata", label: "       Adjustments to Equity", key: "Adj_Equity", parentKey: "Share_Capital" },
    { type: "subdata", label: "    Preference Capital Paid Up", key: "Preference_Capital", parentKey: "Share_Capital" },
    { type: "subdata", label: "    Face Value", key: "FACE_VALUE", parentKey: "Share_Capital" },
    
    { type: "data", label: "Total Reserves", key: "Reserve", expandable: true },
    { type: "subdata", label: "       Securities Premium", key: "Share_Premium", parentKey: "Reserve" },
    { type: "subdata", label: "     Capital Reserves", key: "Capital_Reserve", parentKey: "Reserve" },
    { type: "subdata", label: "      Profit & Loss Account Balance", key: "Profit_Loss", parentKey: "Reserve" },
    { type: "subdata", label: "        General Reserves", key: "General_Reserve", parentKey: "Reserve" },
    { type: "subdata", label: "       Other Reserves", key: "RESERVE-SHARE_PREMIUM-CAPITAL_RESERVE-PROFIT_LOSS-GENERAL_RESERVE", parentKey: "Reserve" },


    { type: "data", label: "Shareholder's Funds", key: "Sharehoders_funds",  },


    { type: "data", label: "Long-Term Borrowings", key: "Ltrm_Borrowing" },


    { type: "data", label: "Secured Loans", key: "Secured_Loans",  expandable: true },
    { type: "subdata", label: "          Non Convertible Debentures", key: "Non_Convertible_Debenture", parentKey: "Secured_Loans" },
    { type: "subdata", label: "        Converible Debentures & Bonds", key: "Conv_Debenture_Bnds", parentKey: "Secured_Loans" },
    { type: "subdata", label: "        Packing Credit - Bank", key: "Packing_Credit", parentKey: "Secured_Loans" },
    { type: "subdata", label: "          Inter Corporate & Security Deposit", key: "Intercorpsecdeposits", parentKey: "Secured_Loans" },
    { type: "subdata", label: "         Term Loans - Banks", key: "Term_Loan_Bank", parentKey: "Secured_Loans" },
    { type: "subdata", label: "            Term Loans - Institutions", key: "Term_Loan_Inst", parentKey: "Secured_Loans" },
    { type: "subdata", label: "             Other Secured", key: "Other_Secured", parentKey: "Secured_Loans" },
    // { type: "subdata", label: "             Other Secured", key: "SECURED_LOANS-NON_CONVERTIBLE_DEBENTURE-CONV_DEBENTURE_BNDS-PACKING_CREDIT-INTERCORPSECDEPOSITS-TERM_LOAN_BANK-TERM_LOAN_INST", parentKey: "Secured_Loans" },
    

    { type: "data", label: "Unsecured Loans", key: "Unsecured_Loans_Nf",  expandable: true },
    { type: "subdata", label: "         Fixed Deposits - Public", key: "Fixed_Deposits", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "          Loans and advances from subsidiaries", key: "Loans_Susidiaries", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "         Inter Corporate Deposits (Unsecured)", key: "Inter_Corp_Deposits", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "          Foreign Currency Convertible Notes", key: "Foreign_Curr_Convertible_Notes", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "       Long Term Loan in Foreign Currency", key: "Foreign_Curr_Long_Term_Loans", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "           Loans - Banks", key: "Loans_Bank", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "             Loans - Govt.", key: "Loans_Govt", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "             Loans - Others", key: "Loans_Others", parentKey: "Unsecured_Loans_Nf" },
    { type: "subdata", label: "      Other Unsecured Loan", key: "Other_Unsecured_Loan", parentKey: "Unsecured_Loans_Nf" },
    // { type: "subdata", label: "        Other Unsecured Loan", key: "UNSECURED_LOANS_NF-FIXED_DEPOSITS-LOANS_SUSIDIARIES-INTER_CORP_DEPOSITS-FOREIGN_CURR_CONVERTIBLE_NOTES-FOREIGN_CURR_LONG_TERM_LOANS-LOANS_BANK-LOANS_GOVT-LOANS_OTHERS", parentKey: "Unsecured_Loans_Nf" },
 
 
    { type: "data", label: "Total Non-Current Liabilities", key: "Total_Nonliab",   },

    // { type: "data", label: "Current Liabilities", key: "Current_Liabilities",  },



    { type: "data", label: "Current Liabilities", key: "Current_Liabilities",  expandable: true },
    { type: "subdata", label: "      Trade Payables", key: "Trade_Payables", parentKey: "Current_Liabilities" },
    { type: "subdata", label: "            Sundry Creditors", key: "Sundry_Crs", parentKey: "Current_Liabilities" },
    { type: "subdata", label: "         Acceptances", key: "Acceptances", parentKey: "Current_Liabilities" },
    { type: "subdata", label: "        Due to Subsidiaries- Trade Payables", key: "Trade_Paysubs", parentKey: "Current_Liabilities" },

    
    { type: "data", label: "Other Current Liabilities", key: "Current_Liabilities_Nf",  expandable: true },
    { type: "subdata", label: "        Bank Overdraft / Short term credit", key: "Bank_Od", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "              Advances received from customers", key: "Adv_Customers", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "             Interest Accrued But Not Due", key: "Interest_Not_Due", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "        Share Application Money", key: "Share_Application", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "                  Current maturity of Debentures & Bonds", key: "Cl_Curmat_Deb", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "               Current maturity - Others", key: "Cl_Curmat_Others", parentKey: "Current_Liabilities_Nf" },
    { type: "subdata", label: "        Other Liabilities", key: "Other_Current_Liabilities", parentKey: "Current_Liabilities_Nf" },
    // { type: "subdata", label: "        Other Liabilities", key: "CURRENT_LIABILITIES_NF-BANK_OD-ADV_CUSTOMERS-INTEREST_NOT_DUE-SHARE_APPLICATION-CL_CURMAT_DEB-CL_CURMAT_OTHERS", parentKey: "Current_Liabilities_Nf" },
    

    { type: "data", label: "Short Term Borrowings", key: "St_Borrowings",  expandable: true },
    { type: "subdata", label: "       Secured ST Loans repayable on Demands", key: "Stbs_Sec_Loandemand", parentKey: "St_Borrowings" },
    { type: "subdata", label: "             Working Capital Loans- Sec", key: "Stbs_Wcap", parentKey: "St_Borrowings" },
    { type: "subdata", label: "             Buyers Credits - Unsec", key: "Stbu_Buycredit", parentKey: "St_Borrowings" },
    { type: "subdata", label: "         Commercial Borrowings- Unsec", key: "Stbu_Commborr", parentKey: "St_Borrowings" },
    { type: "subdata", label: "            Other Unsecured Loans", key: "Other_Unsecured_Loans_St_Borrowings", parentKey: "St_Borrowings" },
    // { type: "subdata", label: "            Other Unsecured Loans", key: "ST_BORROWINGS-STBS_SEC_LOANDEMAND-STBS_WCAP-STBU_BUYCREDIT-STBU_COMMBORR", parentKey: "St_Borrowings" },


    { type: "data", label: "Short Term Provisions", key: "Provisions",  expandable: true },
    { type: "subdata", label: "        Proposed Equity Dividend", key: "Proposed_Divided", parentKey: "Provisions" },
    { type: "subdata", label: "                Provision for Corporate Dividend Tax", key: "Prov_Corp_Tax", parentKey: "Provisions" },
    { type: "subdata", label: "                 Provision for Tax", key: "Prov_Tax", parentKey: "Provisions" },
    { type: "subdata", label: "           Provision for post retirement benefits", key: "Prov_Retirements", parentKey: "Provisions" },
    { type: "subdata", label: "              Preference Dividend", key: "Prefence_Dividend", parentKey: "Provisions" },
    { type: "subdata", label: "               Other Provisions", key: "Other_Provisions_TAX", parentKey: "Provisions" },
    // { type: "subdata", label: "                 Other Provisions", key: "PROVISIONS-PROPOSED_DIVIDED-PROV_CORP_TAX-PROV_TAX-PROV_RETIREMENTS-PREFENCE_DIVIDEND", parentKey: "Provisions" },


    
    { type: "data", label: "Total Current Liabilities", key: "Current_Laib_Prov_Nf",  },
    { type: "data", label: "Total Liabilities", key: "Total_Sounces_Funds_Nf",  },
    
    { type: "heading", label: "ASSETS" },
    { type: "data", label: "ASSETS", key: "ASSETS_S",  expandable: true },
    { type: "subdata", label: "    Gross Block", key: "Gross_block", parentKey: "ASSETS_S" },
    { type: "subdata", label: "          Less: Accumulated Depreciation", key: "Acc_Depreciation", parentKey: "ASSETS_S" },
    { type: "subdata", label: "               Less: Impairment of Assets", key: "Impairment_assets", parentKey: "ASSETS_S" },
    { type: "subdata", label: "          Net Block", key: "Net_Block", parentKey: "ASSETS_S" },
    { type: "subdata", label: "            Long Term Investment", key: "Long_Term_Investments_Nf", parentKey: "ASSETS_S" },
    { type: "subdata", label: "                  Quoted", key: "Long_Term_Quoted", parentKey: "ASSETS_S" },
    { type: "subdata", label: "                      Unquoted", key: "Long_Term_Quoted", parentKey: "ASSETS_S" },
    { type: "subdata", label: "                  Long Term Loans & Advances", key: "Lt_Loanadv", parentKey: "ASSETS_S" },
    { type: "subdata", label: "                  Other Non Current Assets", key: "Other_Noc_Assets", parentKey: "ASSETS_S" },
    { type: "subdata", label: "                  Total Non-Current Assets", key: "Total_Nonassets", parentKey: "ASSETS_S" },



    { type: "data", label: "Current Assets  Loans & Advances", key: "Current_Assets_LoansAdvances",  expandable: true },
    { type: "subdata", label: "   Currents Investments", key: "Current_Investments", parentKey: "Current_Assets_LoansAdvances" },
    { type: "subdata", label: "            Quoted", key: "CURRENT_QUOTED", parentKey: "Current_Assets_LoansAdvances" },
    { type: "subdata", label: "              Inventories", key: "Inventory", parentKey: "Current_Assets_LoansAdvances" },
    { type: "subdata", label: "           Raw Materials", key: "Raw_Material", parentKey: "Current_Assets_LoansAdvances" },
    { type: "subdata", label: "             Debtors more than Six months", key: "Drs_Six_Months", parentKey: "Current_Assets_LoansAdvances" },
    { type: "subdata", label: "                    Debtors Others", key: "Drs_Others", parentKey: "Current_Assets_LoansAdvances" },
   
   
    { type: "data", label: "Cash and Bank", key: "Cash_Bank",  expandable: true },
    { type: "subdata", label: "     Cash in hand", key: "Cash_Hand", parentKey: "Cash_Bank" },
    { type: "subdata", label: "   Balances at Bank", key: "Bank_Balance", parentKey: "Cash_Bank" },
    { type: "subdata", label: "  Other cash and bank balances", key: "OTHER_CASH_BANKBALANCE", parentKey: "Cash_Bank" },
    // { type: "subdata", label: "  Other cash and bank balances", key: "CASH_BANK-CASH_HAND-BANK_BALANCE", parentKey: "Cash_Bank" },


    { type: "data", label: "Other Current Assets", key: "Other_Current_Nf",  expandable: true },
    { type: "subdata", label: "         Deposits with Government", key: "Deposits_Govt_Other", parentKey: "Other_Current_Nf" },
    { type: "subdata", label: "          Interest accrued and or due on loans", key: "Interest_Accrued_Due", parentKey: "Other_Current_Nf" },
    { type: "subdata", label: "       Prepaid Expenses", key: "Prepaid_Exps", parentKey: "Other_Current_Nf" },
    { type: "subdata", label: "     Other current_assets", key: "current_assets_Other_Current_Nf", parentKey: "Other_Current_Nf" },
    // { type: "subdata", label: "     Other current_assets", key: "OTHER_CURRENT_NF-INTEREST_INVESTMENTS-INTEREST_DEBENTURES-DEPOSITS_GOVT_OTHER-INTEREST_ACCRUED_DUE-PREPAID_EXPS", parentKey: "Other_Current_Nf" },


    { type: "data", label: "Short Term Loans and Advances", key: "Loans_Adv",  expandable: true },
    { type: "subdata", label: "           Advances recoverable in cash or in kind", key: "Adv_Cash_Kind", parentKey: "Loans_Adv" },

    { type: "data", label: "Total Current Assets", key: "Currant_Assets_Nf",  expandable: true },
    { type: "subdata", label: "        Net Current Assets (Including Current Investments)", key: "Net_Current_Assets_Nf", parentKey: "Currant_Assets_Nf" },
    { type: "subdata", label: "       Miscellaneous Expenses not written off", key: "Misc_Exps_Not_Wo", parentKey: "Currant_Assets_Nf" },

    { type: "data", label: "Total Assets", key: "Total_Applications_Nf",  expandable: true },
    { type: "subdata", label: "       Contingent Liabilities", key: "Contingent_liabilities", parentKey: "Total_Applications_Nf" },

    { type: "data", label: "Total Debt", key: "Total_Debt_Inclst_Nf",  expandable: true },




  ];


  const formatFincode = (fincode) => {
    const fincodeNumber = parseInt(fincode, 10);
    const year = Math.floor(fincodeNumber / 100);
    const month = fincodeNumber % 100;
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${year}-${monthNames[month - 1]}`;
  };
  const getSafeNumber = (val) => {
    if (val === undefined || val === null || val === "") return 0; // Fallback for empty values
    const cleaned = String(val).replace(/,/g, "").trim(); // Remove commas and whitespace
    const num = parseFloat(cleaned); // Try converting to float
    return isNaN(num) ? 0 : num; // If not a number, fallback to 0
  };



  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Financial Data ({selectedCompany.fincode})
      </h2>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : Bsdata.length === 0 ? (
        <p className={styles.noDataText}>No data available.</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={`table-sm ${styles.table}`}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Metrics</th>
                {years.map((year, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {formatFincode(year)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {financialData.map((item, index) => {
                if (item.type === "heading") {
                  return (
                    <tr key={index} className={styles.sectionRow}>
                      <td colSpan={years.length + 1} className={styles.sectionHeader}>
                        {item.label}
                      </td>
                    </tr>
                  );
                }

                if (item.type === "data") {
                  return (
                    <React.Fragment key={index}>
                      <tr className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          {item.expandable ? (
                            <button
                              onClick={() => toggleRowVisibility(item.key)}
                              className={styles.toggleButton}
                            >
                              {expandedRows[item.key] ? "-" : "+"} {item.label}
                            </button>
                          ) : (
                            item.label
                          )}
                        </td>
                        {Bsdata.map((data, idx) => (
                          <td key={idx} className={styles.tableCell}>
                            {(item.key === "operating_profit_excl_OI") ? (
                              (() => {
                                const netSales = getSafeNumber(data?.Net_sales);
                                const totalExpenditure = getSafeNumber(data?.Total_expendiure);
                                const result = netSales - totalExpenditure;
                                return result.toFixed(2);
                              })()
                            ) : (
                              data[item.key] ?? "–"
                            )}
                          </td>
                        ))}

                      </tr>

                      {/* Show sub-rows when the expandable row is expanded */}
                      {expandedRows[item.key] &&
                        financialData
                          .filter((subItem) => subItem.type === "subdata" && subItem.parentKey === item.key)
                          .map((subItem, subIndex) => (
                            <tr key={`${index}-${subIndex}`} className={styles.subRow}>
                              <td className={styles.subRowCell}>
                                {subItem.label}
                              </td>
                              {Bsdata.map((data, idx) => (
                                <td key={idx} className={styles.subRowCell}>
                                  {(subItem.key === "RESERVE-SHARE_PREMIUM-CAPITAL_RESERVE-PROFIT_LOSS-GENERAL_RESERVE" || subItem.key === "Other_Secured" || subItem.key === "Other_Unsecured_Loan" || subItem.key === "Other_Current_Liabilities" || subItem.key === "Other_Unsecured_Loans_St_Borrowings" || subItem.key === "Other_Provisions_TAX" || subItem.key === "OTHER_CASH_BANKBALANCE" || subItem.key === "current_assets_Other_Current_Nf" ) ? (
                                    (() => {
                                      if (subItem.key === "RESERVE-SHARE_PREMIUM-CAPITAL_RESERVE-PROFIT_LOSS-GENERAL_RESERVE") {
                                        const totalReserve = getSafeNumber(data?.Reserve);
                                        const sharePremium = getSafeNumber(data?.Share_Premium);
                                        const capitalReserve = getSafeNumber(data?.Capital_Reserve);
                                        const profitLoss = getSafeNumber(data?.Profit_Loss);
                                        const generalReserve = getSafeNumber(data?.General_Reserve);
                                      
                                        const otherReserves = totalReserve - sharePremium - capitalReserve - profitLoss - generalReserve;
                                        return otherReserves.toFixed(2);
                                      }
                                      

                                      if (subItem.key === "Other_Secured") {
                                        const totalSecuredLoans = getSafeNumber(data?.Secured_Loans);
                                        const nonConvertibleDeb = getSafeNumber(data?.Non_Convertible_Debenture);
                                        const convertibleDeb = getSafeNumber(data?.Conv_Debenture_Bnds);
                                        const packingCredit = getSafeNumber(data?.Packing_Credit);
                                        const intercorpDeposits = getSafeNumber(data?.Intercorpsecdeposits);
                                        const termLoanBank = getSafeNumber(data?.Term_Loan_Bank);
                                        const termLoanInst = getSafeNumber(data?.Term_Loan_Inst);
                                      
                                        const otherSecured = totalSecuredLoans - nonConvertibleDeb - convertibleDeb - packingCredit - intercorpDeposits - termLoanBank - termLoanInst;
                                        return otherSecured.toFixed(2);
                                      }
                                      

                                      if (subItem.key === "Other_Unsecured_Loan") {
                                        const totalUnsecured = getSafeNumber(data?.Unsecured_Loans_Nf);
                                        const fixedDeposits = getSafeNumber(data?.Fixed_Deposits);
                                        const loansSubsidiaries = getSafeNumber(data?.Loans_Susidiaries);
                                        const interCorpDeposits = getSafeNumber(data?.Inter_Corp_Deposits);
                                        const foreignNotes = getSafeNumber(data?.Foreign_Curr_Convertible_Notes);
                                        const foreignLoans = getSafeNumber(data?.Foreign_Curr_Long_Term_Loans);
                                        const bankLoans = getSafeNumber(data?.Loans_Bank);
                                        const govtLoans = getSafeNumber(data?.Loans_Govt);
                                        const otherLoans = getSafeNumber(data?.Loans_Others);
                                      
                                        const otherUnsecured = totalUnsecured - fixedDeposits - loansSubsidiaries - interCorpDeposits - foreignNotes - foreignLoans - bankLoans - govtLoans - otherLoans;
                                        return otherUnsecured.toFixed(2);
                                      }
                                      

                                      if (subItem.key === "Other_Current_Liabilities") {
                                        const totalCurrentLiabilities = getSafeNumber(data?.Current_Liabilities_Nf);
                                        const bankOd = getSafeNumber(data?.Bank_Od);
                                        const advCustomers = getSafeNumber(data?.Adv_Customers);
                                        const interestNotDue = getSafeNumber(data?.Interest_Not_Due);
                                        const shareApplication = getSafeNumber(data?.Share_Application);
                                        const debMaturity = getSafeNumber(data?.Cl_Curmat_Deb);
                                        const otherMaturity = getSafeNumber(data?.Cl_Curmat_Others);
                                      
                                        const otherLiabilities = totalCurrentLiabilities - bankOd - advCustomers - interestNotDue - shareApplication - debMaturity - otherMaturity;
                                        return otherLiabilities.toFixed(2);
                                      }
                                      

                                      

                                      if (subItem.key === "Other_Unsecured_Loans_St_Borrowings") {
                                        const totalBorrowings = getSafeNumber(data?.St_Borrowings);
                                        const loanDemand = getSafeNumber(data?.Stbs_Sec_Loandemand);
                                        const workingCap = getSafeNumber(data?.Stbs_Wcap);
                                        const buyerCredits = getSafeNumber(data?.Stbu_Buycredit);
                                        const commBorrowings = getSafeNumber(data?.Stbu_Commborr);
                                      
                                        const otherUnsecured = totalBorrowings - loanDemand - workingCap - buyerCredits - commBorrowings;
                                        return otherUnsecured.toFixed(2);
                                      }
                                      

                                      if (subItem.key === "Other_Provisions_TAX") {
                                        const totalPROVISION = getSafeNumber(data?.Provisions);
                                        const proposedDividend = getSafeNumber(data?.Proposed_Divided);
                                        const corpTax = getSafeNumber(data?.Prov_Corp_Tax);
                                        const taxPROV = getSafeNumber(data?.Prov_Tax);
                                        const retirement = getSafeNumber(data?.Prov_Retirements);
                                        const prefDividend = getSafeNumber(data?.Prefence_Dividend);
                                      
                                        const otherProvisions = totalPROVISION - proposedDividend - corpTax - taxPROV - retirement - prefDividend;
                                        return otherProvisions.toFixed(2);
                                      }

                                      if (subItem.key === "OTHER_CASH_BANKBALANCE") {
                                        const total = getSafeNumber(data?.Cash_Bank);
                                        const cashHand = getSafeNumber(data?.Cash_Hand);
                                        const bankBalance = getSafeNumber(data?.Bank_Balance);
                                      
                                        const otherCashBank = total - cashHand - bankBalance;
                                        return otherCashBank.toFixed(2);
                                      }
                                      
                              

                                      if (subItem.key === "current_assets_Other_Current_Nf") {
                                        const total = getSafeNumber(data?.Other_Current_Nf);
                                        const depositsGovt = getSafeNumber(data?.Deposits_Govt_Other);
                                        const interestAccrued = getSafeNumber(data?.Interest_Accrued_Due);
                                        const prepaidExps = getSafeNumber(data?.Prepaid_Exps);
                                      
                                        const otherAssets = total - depositsGovt - interestAccrued - prepaidExps;
                                        return otherAssets.toFixed(2);
                                      }
                                      





                                      return "–";
                                    })()
                                  ) : (
                                    data[subItem.key] ?? "–"
                                  )}



                                </td>
                              ))}
                            </tr>
                          ))}
                    </React.Fragment>
                  );
                }

                return null;
              })}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default BalanceSheet;
